<div class="pie-chart" #piechart>
  <div
    *ngFor="let data of chartData"
    class="slice"
    [ngStyle]="pieStyle[data.label]"
  ></div>
  <div class="center" *ngIf="hasReady">
    <div class="center-text">
      <p>Total</p>
      <p>{{ totalClaim }}</p>
    </div>
  </div>
</div>
